import { Component, OnInit} from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { VariablesService } from '../../services/variables.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  templateUrl: './agreements.component.html',
    styleUrls: ['./agreements.component.scss'],
  standalone: false
})
export class AgreementsComponent implements OnInit {
  isSubmitting: boolean;
  attendee: any;
  enrollment: any;
  emailFormArray: Array<any> = [];
  otherChecked: boolean;
  varCancelPolicy;
  varTravelPolicy;
  varTrack;
  varCodeOfConduct;
  isFormCompleted=false;
  isRegComplete;
  nameBadgeAck;

  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private variablesService: VariablesService,
    public modalService: ModalService

  ) {
    this.attendee = this.registrationService.getAttendee({});
    this.enrollment = this.registrationService.getEnrollment({});
    this.isRegComplete = this.registrationService.isRegistrationComplete();

    this.varCancelPolicy = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varCancelPolicy.ID,
      {}
    );

    this.varTravelPolicy = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varTravelPolicy.ID,
      {}
    );
    this.varTrack = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varTrack.ID,
      {}
    );
    this.varCodeOfConduct = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varCodeOfConduct.ID,
      {}
    );
    this.nameBadgeAck = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.varNameBadgeAck.ID,
      {}
    );

    if ( this.varCancelPolicy.Value === "Agreed") {
      this.enrollment.$mtccancelpolicy = true;
    }

    if (this.varTravelPolicy.Value === "Agreed") {
      this.enrollment.$mtctravelpolicy = true
     }
 
     if (this.varCodeOfConduct.Value === "Agreed" ) {
       this.enrollment.$mtccodeofconduct = true;
     }
 
     if ( this.nameBadgeAck.Value === "Agreed") {
       this.enrollment.$mtcNameBadgeAck = true;
     }

  }
  ngOnInit(): void { }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }

  openModalExternal(url, title, actionButtonText) {
    this.modalService.openModalExternal(url, title, actionButtonText);
  }

  /**
   * @function back
   * @description Uses [navigation.service.back()] to go back to previous page.
   */
  back() {
    this.navigationService.back();
  }

  /**
   * @function forward
   * @description Checks if form is valid then uses [navigation.service.forward()] to go forward to next page.
   */
  forward(form) {
    this.isFormCompleted=true;
    if (form.valid) {

      if (this.enrollment.$mtctravelpolicy === true) {
        this.varTravelPolicy.Value = "Agreed";
      }
  
      if (this.enrollment.$mtccodeofconduct === true) {
        this.varCodeOfConduct.Value = "Agreed";
      }

      if (this.enrollment.$mtccancelpolicy === true) {
        this.varCancelPolicy.Value = "Agreed";
      }
      if (this.enrollment.$mtcNameBadgeAck === true) {
        this.nameBadgeAck.Value = "Agreed";
      }

      if (this.enrollment.AgreedToTermsAndConditions) {
        this.enrollment.ResponsibilityStatement = true;
      }
    this.isSubmitting = true;
    this.navigationService.forward();
    }
  }
}
